import { useEffect, useState } from "react";
import { FormProvider } from "../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import { Form, Input, InputNumber, Select } from "antd";
import style from "./style.module.scss";
import { SimpleInput } from "../../../common/components/simpleInput";
import { StoreStorageService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { handleNumericDecimalInput } from "../../../common/utils/numericInputHandler";

type StoreStorageFormType = {
  onFinish: () => void;
  initialValue?: any;
};

const StoreStorageForm = ({ onFinish, initialValue }: StoreStorageFormType) => {
  const [form] = Form.useForm();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      form.setFieldsValue({
        ...initialValue,
        name: initialValue.name,
        capacity: initialValue.capacity,
        cementCapacity: initialValue.cementCapacity,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        capacity: values.capacity.toString(),
        cementCapacity: values.cementCapacity.toString(),
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
      };

      if (!dataToPost?.id) {
        const res = await StoreStorageService.postStoreStorage(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        const res = await StoreStorageService.patchStoreStorage(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Nom"
                name={"name"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
          </div>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Capacité (T)"
                name={"capacity"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Input className={style.form__input} onKeyDown={handleNumericDecimalInput}/>
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Capacité ciment (T)"
                name={"cementCapacity"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Input
                    className={style.form__input}
                    onKeyDown={handleNumericDecimalInput}
                  />
                }
              />
            </div>
          </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};

export default StoreStorageForm;
